import { GET_PATIENT_ADDRESS } from './constants';
import fetchWithRefreshV2 from './fetchWithRefreshV2';

export interface Response {
    success: boolean;
    address: Add[];
    error: string;
}

export interface Add {
    _id: string;
    pid: string;
    docid: string;
    uuid: string;
    address: AddressObj;
    created_at: string;
}

export interface AddressObj {
    line1: string;
    line2: string;
    city: string;
    state: string;
    city_id: string;
    place_id: string;
    coordinates: string;
    pincode: string;
}

export default (patient_oid: string): Promise<Response> => {
    return fetchWithRefreshV2(GET_PATIENT_ADDRESS(patient_oid)).then((res) => res.json());
};
